import axios from 'axios';

const getLoad = ({ loadId }) => axios.get(`load/${loadId}`);
const myCounts = () => axios.get('myDay/myCounts');
const assignDriver = ({ loadId, driverId }) => axios.post(`load/${loadId}/assignDriver`, {
  driverUserId: driverId || null,
});
const getByStatus = ({ status }) => axios.get(`load/status/${status}`);
const getListing = ({ listingId }) => axios.get(`loadListing/${listingId}`);
const getListings = () => axios.get('loadListing');
const getFulfillment = ({ loadId }) => axios.get(`timeline/load/${loadId}/fulfillment`);
const updateFulfillment = ({ loadId, messageRequest }) => axios.post(`timeline/load/${loadId}/fulfillment`, messageRequest);
/** this takes a local date/time.  the timezone is implied by the location */
const updatePickupETA = ({ loadId, eta }) => axios.post(`load/${loadId}/pickup/eta`, { eta });
/** estimatedDelivery is a local date/time.  the timezone is implied by the destination location */
const updateDeliveryETA = ({ loadId, eta }) => axios.post(`load/${loadId}/deliver/eta`, { eta });
const setPickup = ({ loadId, pickupInfo }) => axios.post(`load/${loadId}/pickup`, pickupInfo);
const setDelivered = ({ loadId, dropoffInfo }) => axios.post(`load/${loadId}/deliver`, dropoffInfo);
const setPaid = ({ loadId, paymentInfo }) => axios.post(`load/${loadId}/payment`, paymentInfo);
const setCanceled = ({ loadId }) => axios.delete(`load/${loadId}`);
const acknowledgePayment = ({ loadId, paymentInfo }) => axios.post(`load/${loadId}/acknowledgePayment`, paymentInfo);
const uploadBOL = ({ loadId, billOfLadingNumber, billOfLadingBase64s, doc, config = {} }) =>
  axios.post(`load/${loadId}/attachBillOfLading`, {
    document: doc || 'BillOfLading',
    documentName: billOfLadingNumber,
    pages: billOfLadingBase64s.map(b => ({ base64EncodedData: b })),
  }, config);
const uploadInspectionPapers = ({ loadId, inspectionPapersBase64s, config }) =>
  axios.post(`load/${loadId}/attachDocument`, {
    document: 'InspectionPapers',
    pages: inspectionPapersBase64s[0].map(b => ({ base64EncodedData: b })),
  },
  config);
const redoBOL = ({ loadId }) => axios.post(`load/${loadId}/recreateBillOfLading`);

const uploadFulfillmentPhoto = ({ loadId, name, photoBase64s, config }) =>
  axios.post(`timeline/load/${loadId}/fulfillment/file`, {
    message: name,
    base64EncodedData: photoBase64s[0][0],
    sent: new Date().toISOString(),
  }, config);
const checkIn = ({ lat, lng, timestamp, loadId }) => axios.post(`load/${loadId}/checkin`, {
  timestamp,
  currentLat: lat,
  currentLng: lng,
});

const cancelListing = ({ listingId }) => axios.delete(`loadListing/${listingId}`);
const untethered = () => axios.get('loadListing/untethered');

export default {
  getLoad,
  myCounts,
  assignDriver,
  getByStatus,
  getListing,
  getListings,
  getFulfillment,
  updateFulfillment,
  updatePickupETA,
  updateDeliveryETA,
  setPickup,
  setDelivered,
  setPaid,
  setCanceled,
  acknowledgePayment,
  uploadBOL,
  uploadInspectionPapers,
  uploadFulfillmentPhoto,
  checkIn,
  cancelListing,
  untethered,
  redoBOL,
};



// WEBPACK FOOTER //
// ./src/api/load.js